const downloadFile = (file, defaultFileName) => {
  const fileURL = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.download = defaultFileName ?? file.name;
  a.href = fileURL;
  a.click();
  URL.revokeObjectURL(fileURL);
};

export default downloadFile;
